export const addDays = (date: Date, number: number) => {
    const newDate = new Date(date)
    return new Date(newDate.setDate(newDate.getDate() + number))
}
